






























































































































































import { computed, defineComponent, ref } from '~/utils/nuxt3-migration'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useNamespacedStore } from '~/compositions/store'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/favorite/CClassifiedFavoriteButton.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import MarketplaceProductAvailabilityBadge from '~/components/car/marketplace/product/MarketplaceProductAvailabilityBadge.vue'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { formatPrice } from '~/utils/number'
import { ciCart } from '~/icons/source/regular/cart'
import MarketplaceSellerModalTrigger from '~/components/car/marketplace/seller/MarketplaceSellerModalTrigger.vue'
import { ciShipping } from '~/icons/source/regular/shipping'
import { ciEshop } from '~/icons/source/regular/e-shop'
import { ciMinus } from '~/icons/source/light/minus'
import { ciPlus } from '~/icons/source/light/plus'
import MarketplaceSectionCartButton from '~/components/car/classifieds/view/partials/marketplace/MarketplaceSectionCartButton.vue'
import { useI18n } from '~/compositions/i18n'
import { PropType } from 'vue'
import {
  ClassifiedMarketplaceInfo,
  CurrentUser
} from '~/models/classified/view'
import { Classified } from '~/models/classified/types'

export default defineComponent({
  components: {
    MarketplaceSectionCartButton,
    CPrice,
    MarketplaceProductAvailabilityBadge,
    CClassifiedFavoriteButton,
    MarketplaceSellerModalTrigger
  },
  props: {
    marketplace: {
      type: Object as PropType<ClassifiedMarketplaceInfo>,
      required: true
    },
    classified: {
      type: Object as PropType<Classified>,
      required: true
    },
    currentUser: {
      type: Object as PropType<CurrentUser | null>,
      required: true
    }
  },
  setup(props) {
    const {
      dispatch: classifiedViewDispatch,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)
    const { t } = useI18n()

    const loading = ref(false)
    const hasProductInCart = ref(props.marketplace.cart.productQuantity > 0)

    const isDealerSiteVariant = computed(() =>
      classifiedViewGetters('isDealerSiteVariant')
    )

    const estimatedDeliveryText = computed(() => {
      const availability = props.marketplace.product?.availability
      if (!availability) {
        return ''
      }

      switch (availability) {
        case '1_3_days':
          return t('estimated_delivery_days', { from: 1, to: 3 })
        case '4_10_days':
          return t('estimated_delivery_days', { from: 4, to: 10 })
        case '10_30_days':
          return t('estimated_delivery_days', { from: 10, to: 30 })
        default: {
          return ''
        }
      }
    })

    function onClassifiedParkedChange(isParked: boolean) {
      classifiedViewDispatch('classifiedParkedStateChanged', isParked)
    }

    function onAddToCart() {
      hasProductInCart.value = true
    }

    function onRemoveFromCart() {
      hasProductInCart.value = false
    }

    return {
      ciCart,
      ciShipping,
      ciEshop,
      ciPlus,
      ciMinus,
      loading,
      estimatedDeliveryText,
      isDealerSiteVariant,
      hasProductInCart,
      formatPrice,
      onAddToCart,
      onRemoveFromCart,
      onClassifiedParkedChange
    }
  },
  i18n: defineComponentTranslations({
    add_to_cart: {
      en: 'Add to cart',
      el: 'Προσθήκη στο καλάθι'
    },
    sold_by: {
      en: 'Sold by',
      el: 'Πωλείται από'
    },
    ability_to_pickup_from_store: {
      en: 'Ability to pickup from store',
      el: 'Δυνατότητα παραλαβής από κατάστημα'
    }
  })
})
